import Navbar from "../components/navbar";
import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";
import personalloanmain from '../Assests/personal loan.jpeg'

function PersonalLoan() {
    const [isVisible, setIsVisible] = useState(false);

    // 👇 ye add karo taake text page load par show ho
    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 200);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {/* Hero Section */}
            <div
                id="home"
                className="relative min-h-screen bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50"
            >
                <Navbar />

                <div className="relative z-10 flex items-center min-h-[100vh] px-6 lg:px-12 pt-20">
                    <div className="max-w-7xl mx-auto w-full">
                        <div className="grid lg:grid-cols-2 gap-12 items-center">
                            {/* Left content */}
                            <div
                                className={`space-y-6 transition-all duration-1000 ${isVisible
                                    ? "opacity-100 translate-y-0"
                                    : "opacity-0 translate-y-10"
                                    }`}
                            >
                                <div className="space-y-4">
                                    <h1 className="text-3xl lg:text-5xl font-bold text-gray-900 leading-tight">
                                        Unlock the Best Personal Loan Offers in{" "}
                                        <span className="bg-gradient-to-r from-emerald-400 via-teal-500 to-green-400 bg-clip-text text-transparent">
                                            UAE
                                        </span>
                                    </h1>

                                    <h2 className="text-2xl font-semibold text-gray-800">
                                        Flexible terms, competitive rates, and fast approval — check
                                        your eligibility in minutes.
                                    </h2>

                                    <p className="text-base lg:text-lg text-gray-700 max-w-lg leading-relaxed">
                                        Up to UAE 5 Million | Quick Approval in 24 Hrs | Competitive
                                        Interest Rates
                                    </p>
                                </div>

                                {/* CTA Button */}
                                <div className="pt-2">
                                    <NavLink to="/checkout">
                                        <button className="group inline-flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-8 py-4 rounded-full text-base lg:text-lg font-semibold hover:from-emerald-400 hover:to-teal-500 transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-emerald-500/25">
                                            Apply For Personal Loan
                                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                                        </button>
                                    </NavLink>
                                </div>
                            </div>

                            {/* Right image */}
                            <div
                                className={`relative flex justify-center lg:justify-end transition-all duration-1000 delay-500 ${isVisible
                                    ? "opacity-100 translate-y-0"
                                    : "opacity-0 translate-y-10"
                                    }`}
                            >
                                <div className="relative">
                                    <div className="w-80 h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden flex items-center justify-center shadow-xl border-4 border-white">
                                        <img
                                            src={personalloanmain}
                                            alt="Loan Services"
                                            className="object-cover w-full h-full"
                                        />
                                    </div>
                                    <div className="absolute inset-0 w-80 h-80 lg:w-96 lg:h-96 rounded-full bg-gradient-to-br from-emerald-300/40 via-teal-300/30 to-green-300/40 blur-xl scale-110 animate-pulse"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Personal Loan Info Section */}
            <section className="py-16 px-6 lg:px-12 bg-white" id="info">
                <div className="max-w-6xl mx-auto space-y-12">
                    <h2 className="text-3xl font-bold text-gray-900 text-center">
                        Personal Loans in the UAE
                    </h2>
                    <p className="text-lg text-gray-700 text-center max-w-3xl mx-auto">
                        Need extra cash for a wedding, travel, home renovation, or to clear
                        existing debts? A personal loan can give you quick access to funds
                        with low interest rates, fast approval, and flexible repayment
                        options. Top banks and trusted lenders in the UAE offer salary
                        transfer loans, non-salary transfer loans, and loan buyouts to help
                        you achieve your financial goals with ease.
                    </p>

                    {/* Compare Table */}
                    <div className="overflow-x-auto">
                        <h3 className="text-2xl font-semibold mb-6 text-center">
                            Compare Personal Loan Offers in the UAE
                        </h3>
                        <table className="w-full border-collapse shadow-md rounded-lg overflow-hidden">
                            <thead>
                                <tr className="bg-emerald-600 text-white text-left">
                                    <th className="p-4">Bank</th>
                                    <th className="p-4">Max Loan Amount</th>
                                    <th className="p-4">Interest Rate Starting</th>
                                    <th className="p-4">Salary Transfer</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                <tr>
                                    <td className="p-4">Emirates NBD</td>
                                    <td className="p-4">Up to AED 4,000,000</td>
                                    <td className="p-4">Starting from 5.49% p.a.</td>
                                    <td className="p-4">Required</td>
                                </tr>
                                <tr>
                                    <td className="p-4">ADCB</td>
                                    <td className="p-4">Up to AED 2,500,000</td>
                                    <td className="p-4">Starting from 6.25% p.a.</td>
                                    <td className="p-4">Not Required</td>
                                </tr>
                                <tr>
                                    <td className="p-4">Mashreq Bank</td>
                                    <td className="p-4">Up to AED 1,500,000</td>
                                    <td className="p-4">Starting from 5.99% p.a.</td>
                                    <td className="p-4">Required</td>
                                </tr>
                                <tr>
                                    <td className="p-4">FAB (First Abu Dhabi Bank)</td>
                                    <td className="p-4">Up to AED 5,000,000</td>
                                    <td className="p-4">Starting from 4.99% p.a.</td>
                                    <td className="p-4">Not Required</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="py-16 px-6 lg:px-12 bg-gray-50" id="faq">
                <div className="max-w-5xl mx-auto space-y-10">
                    <h2 className="text-3xl font-bold text-gray-900 text-center">
                        Frequently Asked Questions
                    </h2>
                    <div className="space-y-6">
                        <div>
                            <h3 className="font-semibold text-lg">
                                What is the minimum salary required for a personal loan in the UAE?
                            </h3>
                            <p className="text-gray-700">
                                Most banks in the UAE require a minimum monthly income starting
                                from AED 5,000–8,000. Criteria vary by lender.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                How fast can I get approval for my loan?
                            </h3>
                            <p className="text-gray-700">
                                Approval times vary by bank but are usually between 1–3 working
                                days if documents are complete.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                Can I get a loan without salary transfer?
                            </h3>
                            <p className="text-gray-700">
                                Yes, many banks in the UAE offer non-salary transfer personal
                                loans, though terms may differ.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                What documents do I need to apply?
                            </h3>
                            <p className="text-gray-700">
                                Emirates ID, passport copy, visa copy, salary certificate or
                                bank statements are usually required.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                Is early loan settlement possible?
                            </h3>
                            <p className="text-gray-700">
                                Yes, most banks allow early loan settlement, but some may charge
                                a small fee. Always confirm with your lender.
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            {/* FAQ Section */}
            <section className="py-16 px-6 lg:px-12 bg-gray-50" id="faq">
                <div className="max-w-5xl mx-auto space-y-10">
                    <h2 className="text-3xl font-bold text-gray-900 text-center">
                        Frequently Asked Questions
                    </h2>
                    <div className="space-y-6">
                        <div>
                            <h3 className="font-semibold text-lg">
                                What is the minimum salary required for a personal loan in
                                Pakistan?
                            </h3>
                            <p className="text-gray-700">
                                Most banks require a minimum monthly income starting from PKR
                                30,000–40,000. Criteria vary by lender.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                How fast can I get approval for my loan?
                            </h3>
                            <p className="text-gray-700">
                                Approval times vary by bank but are usually between 1–5 working
                                days if documents are complete.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                Can I get a loan without salary transfer?
                            </h3>
                            <p className="text-gray-700">
                                Yes, many banks in Pakistan offer non-salary transfer personal
                                loans, though terms may differ.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                What documents do I need to apply?
                            </h3>
                            <p className="text-gray-700">
                                CNIC, salary slip or bank statements, proof of address, and
                                employer verification are usually required.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                Is early loan settlement possible?
                            </h3>
                            <p className="text-gray-700">
                                Yes, most banks allow early loan settlement, but some may charge
                                a small fee. Always confirm with your lender.
                            </p>
                        </div>
                    </div>
                </div>
            </section>



            {/* ✅ Representative Illustration Section */}
            <section className="py-16 px-6 lg:px-12 bg-gray-50">
                <div className="max-w-5xl mx-auto text-center">
                    <h2 className="text-3xl font-bold text-emerald-700 mb-6">
                        Representative Illustration
                    </h2>

                    {/* Info Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg shadow-md bg-white">
                            <tbody>
                                <tr className="border-b">
                                    <td className="p-4 font-semibold text-gray-700">Repayment Period</td>
                                    <td className="p-4 text-gray-600">6 to 48 months</td>
                                </tr>
                                <tr className="border-b">
                                    <td className="p-4 font-semibold text-gray-700">Maximum APR</td>
                                    <td className="p-4 text-gray-600">Up to 24% per annum</td>
                                </tr>
                                <tr className="border-b">
                                    <td className="p-4 font-semibold text-gray-700">Processing Fee</td>
                                    <td className="p-4 text-gray-600">1.05% of loan amount</td>
                                </tr>
                                <tr>
                                    <td className="p-4 font-semibold text-gray-700">
                                        Representative Example
                                    </td>
                                    <td className="p-4 text-gray-600">
                                        AED 50,000 for 24 months at 14% p.a. + 1.05% fee ≈ Total Cost AED
                                        64,160, Monthly AED 2,673
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Disclaimer */}
                    <p className="mt-6 text-sm text-gray-500 leading-relaxed">
                        This is a representative example for illustration only. Actual terms and
                        costs may vary depending on your lender.
                    </p>
                    <p className="mt-2 text-xs text-gray-400">
                        Disclaimer: <span className="font-semibold">AE Finance</span> is an
                        independent platform. We do not grant loans — we connect customers with
                        licensed UAE banks and financial institutions. Final loan amounts,
                        interest rates, fees, and eligibility are decided by the lender. We do not
                        charge you any application fee but may receive a referral commission from
                        banks or agents.
                    </p>
                </div>
            </section>

            {/* ✅ Footer */}
            <footer className="bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50 py-10 px-6 lg:px-12">
                <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Logo + About */}
                    <div>
                        <h3 className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">AE Finance</h3>
                        <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                            Your trusted partner for finding the best loan and credit card deals in
                            the UAE. We connect you with top banks and financial institutions to
                            make borrowing simple and transparent.
                        </p>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-lg font-semibold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">Contact Us</h4>
                        <p className="text-sm text-gray-400">Email: aft4417@gmail.com</p>
                        <p className="text-sm text-gray-400">Phone: +971558720718</p>
                        <p className="text-sm text-gray-400 mt-2">
                            Jebel Ali Free Zone · Street: Po Box 27074. City: Abu Dhabi
                        </p>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-8 border-t border-gray-700 pt-4 text-center text-sm text-gray-500">
                    © {new Date().getFullYear()} AE Finance. All Rights Reserved.
                </div>
            </footer>

        </div>
    );
}

export default PersonalLoan;
